import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Area } from 'src/app/shared/models/area';
import { User } from 'src/app/shared/models/security/user';
import { SortOrder } from 'src/app/shared/pipes/order-by/order-by.pipe';
import { AreaAjoutFormModalComponent } from '../area-ajout-form-modal/area-ajout-form-modal.component';

@Component({
	selector: 'app-list-area',
	templateUrl: './list-area.component.html',
	styleUrls: ['./list-area.component.scss']
})
export class ListAreaComponent implements OnInit {
	areas: Area[];
	currentPage = 0;

	sortType = 'name';
	sortOrder: SortOrder = 'asc';

	nextWeekNumber: number;
	competences: Record<string, string>;

	selectedCompetences: string[] = [];
	selectedCompetencesDisplay: string;

	user: User = null;
	isPlanif = false;

	addAreaModalRef: BsModalRef;

	isAddable = true;
	itemsPerPage = 10;

	isListingLoading: boolean = true;

	constructor(
		private facade: FacadeService,
		private modalService: BsModalService,
		private toastService: ToastService
	) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();
		this.isPlanif = this.facade.dataStorageService.isPlanificatrice();

		this.getAreas();
	}

	getAreas() {
		this.isListingLoading = true;
		this.facade.areaService.getAllAreasForUserCenter().subscribe({
			next: (areas) => {
				this.areas = areas;
				this.itemsPerPage = this.areas.length >= 5 ? 10 : 5;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.toastService.createHttpErrorToast(err.error.message, err.status);
				this.isListingLoading = false;
			}
		});
	}

	/**
	 * Fonction pour les paramètres de trie. Si le string choisi vaut le string courant l'on change l'ordre de trie (croissant/décroissant)
	 * sinon l'on chance la colonne de trie et l'on trie par ordre crosisant
	 * @param str colonne de trie
	 */
	sortChange(str: string): void {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalAjout() {
		if (this.user === null /*|| this.user.employee.serviceCenter === null*/) {
			this.facade.toastService.createErrorToast(
				"Vous n'êtes pas rattaché à un centre."
			);
		} else {
			this.addAreaModalRef = this.modalService.show(
				AreaAjoutFormModalComponent,
				{
					class: 'modal-lg',
					backdrop: 'static'
				}
			);
			this.addAreaModalRef.onHide.subscribe((reason: string | any) => {
				this.getAreas();
			});
		}
	}
}
